import {Component, ViewEncapsulation} from '@angular/core';
import {NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router} from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None  // Style for all pages across application
})

export class AppComponent {

  loading: boolean = false;
  constructor(private router: Router) {
    router.events.subscribe((
      event => {
        if (event instanceof RouteConfigLoadStart /*&& event.route.path === 'lazy'*/) {
          console.log(`START - ${event.route.path}`);
          this.loading = true;
        }
        if (event instanceof RouteConfigLoadEnd /*&& event.route.path === 'lazy'*/) {
          console.log(`FINISH - ${event.route.path}`);
          this.loading = false;
        }
        if (event instanceof NavigationEnd) {
          $('.navbar-collapse').collapse('hide');
        }
      }));
  }
}
